<div class="page-title">
  <h1>Editar módulo</h1>
</div>

<!-- ── Tabs + botão ── -->
<div class="tabs-wrapper">
  <div class="tabs-row">
    <div class="tabs-esquerda">
      <button
        class="tab-btn"
        [class.ativo]="tabAtiva === 'dados'"
        (click)="mudarAba('dados')"
      >
        Dados gerais
      </button>
      <button
        class="tab-btn"
        [class.ativo]="tabAtiva === 'empresas'"
        (click)="mudarAba('empresas')"
      >
        Empresas
      </button>
    </div>

    <button
      *ngIf="tabAtiva === 'empresas'"
      class="btn-cheio"
      (click)="abrirModal()"
    >
      + Adicionar empresa ao módulo
    </button>
  </div>
</div>

<!-- ══════════════════════════════════════════════ -->
<!-- ABA: Dados gerais                             -->
<!-- ══════════════════════════════════════════════ -->
<div *ngIf="tabAtiva === 'dados'" class="tab-content">

  <p class="titulo-secao">CAPA</p>

  <div
    class="upload-area"
    [class.drag-over]="isDragging"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)"
  >
    <button class="btn-cheio btn-upload" type="button" (click)="fileInput.click()">
      + Adicionar imagem de capa
    </button>
    <span class="upload-hint">
      Ou arraste a imagem aqui <strong>(.jpeg e .png, máximo até 5 MB)</strong>
    </span>
    <input
      #fileInput
      type="file"
      accept=".jpg,.jpeg,.png"
      hidden
      (change)="onFileSelected($event)"
    />
  </div>

  <p class="campo-obrigatorio" *ngIf="!temImagem">* Imagem de capa é obrigatória</p>

  <div class="arquivo-preview" *ngIf="arquivoSelecionado">
    <button class="btn-remover-arquivo" type="button" (click)="removerArquivo()">
      <img src="../../../assets/svg/icons/delete_trash.svg" alt="Excluir" style="width: 20px; height: 20px;" />
    </button>
    <div class="arquivo-info">
      <span class="arquivo-nome">{{ arquivoSelecionado.name }}</span>
      <span class="arquivo-tamanho">{{ arquivoTamanho }}</span>
      <span class="arquivo-sucesso">Foto carregada com sucesso</span>
    </div>
  </div>

  <p class="titulo-secao">INFORMAÇÕES GERAIS</p>

  <div class="campos-row">
    <mat-form-field appearance="outline" class="campo-form">
      <mat-label>Nome</mat-label>
      <input matInput [(ngModel)]="modulo.nome" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="campo-form campo-readonly">
      <mat-label>Linha de cuidado</mat-label>
      <input matInput [value]="modulo.linhaDeCuidadoNome" readonly />
    </mat-form-field>
  </div>

  <mat-form-field appearance="outline" class="campo-form campo-full">
    <mat-label>Descrição</mat-label>
    <textarea matInput [(ngModel)]="modulo.descricao" rows="5"></textarea>
  </mat-form-field>

</div>

<!-- ══════════════════════════════════════════════ -->
<!-- ABA: Empresas                                 -->
<!-- ══════════════════════════════════════════════ -->
<div *ngIf="tabAtiva === 'empresas'" class="tab-content">

  <div class="filtros-row">
    <mat-form-field appearance="outline" class="campo-filtro">
      <mat-label>Filtro</mat-label>
      <mat-select [(ngModel)]="campoBusca" (ngModelChange)="filtrarEmpresas()">
        <mat-option value="nomeFantasia">Nome</mat-option>
        <mat-option value="cnpj">CNPJ</mat-option>
        <mat-option value="estado">Estado</mat-option>
        <mat-option value="cidade">Cidade</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="campo-busca">
      <mat-icon matPrefix class="icone-busca">search</mat-icon>
      <input
        matInput
        placeholder="Buscar por nome ou CNPJ"
        [(ngModel)]="termoBusca"
        (ngModelChange)="filtrarEmpresas()"
      />
    </mat-form-field>
  </div>

  <!-- Loading empresas -->
  <div class="loading" *ngIf="isLoadingEmpresas">
    <mat-spinner diameter="36"></mat-spinner>
  </div>

  <table mat-table [dataSource]="dataSource" matSort #sortEmpresas="matSort" class="tabela-empresas" *ngIf="!isLoadingEmpresas">

    <ng-container matColumnDef="nome">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="nomeFantasia">Nome</th>
      <td mat-cell *matCellDef="let empresa">{{ empresa.nomeFantasia }}</td>
    </ng-container>

    <ng-container matColumnDef="cnpj">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="cnpj">CNPJ</th>
      <td mat-cell *matCellDef="let empresa">{{ empresa.cnpj }}</td>
    </ng-container>

    <ng-container matColumnDef="estado">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="estado">Estado</th>
      <td mat-cell *matCellDef="let empresa">{{ empresa.estado }}</td>
    </ng-container>

    <ng-container matColumnDef="cidade">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="cidade">Cidade</th>
      <td mat-cell *matCellDef="let empresa">{{ empresa.cidade }}</td>
    </ng-container>

    <ng-container matColumnDef="acoes">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let empresa">
        <button class="btn-icone" (click)="removerEmpresa(empresa)">
          <img src="../../../assets/svg/icons/delete_trash.svg" alt="Remover" style="width: 20px; height: 20px;" />
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="colunasEmpresas"></tr>
    <tr mat-row *matRowDef="let row; columns: colunasEmpresas"></tr>

    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell sem-dados" [attr.colspan]="colunasEmpresas.length">
        Nenhuma empresas foi adicionada a esse módulo.
      </td>
    </tr>
  </table>

  <div class="rodape-tabela" *ngIf="!isLoadingEmpresas">
    <span class="contagem-resultados">
      Mostrando 1 a {{ pageSize }} de {{ totalEmpresas }} resultados
    </span>
    <div class="paginacao-direita">
      <span class="label-pagina">Resultados por página:</span>
      <mat-select class="select-page-size" [(ngModel)]="pageSize">
        <mat-option [value]="10">10</mat-option>
        <mat-option [value]="25">25</mat-option>
        <mat-option [value]="50">50</mat-option>
      </mat-select>
      <span class="pagina-info">{{ paginaAtual }}-{{ totalPaginas }}</span>
      <button class="btn-nav" [disabled]="paginaAtual === 1" (click)="paginaAnterior()">
        <mat-icon>chevron_left</mat-icon>
      </button>
      <button class="btn-nav" [disabled]="paginaAtual === totalPaginas" (click)="proximaPagina()">
        <mat-icon>chevron_right</mat-icon>
      </button>
    </div>
  </div>

</div>

<!-- ── Rodapé com ações ── -->
<div class="container-inferior">
  <button class="btn-cancelar" type="button" (click)="cancelar()">Cancelar</button>
  <button
    class="btn-cheio"
    type="button"
    (click)="salvar()"
    [disabled]="!formularioValido || isSaving"
  >
    {{ isSaving ? 'Salvando...' : 'Salvar' }}
  </button>
</div>

<!-- ── Modal de adicionar empresas ── -->
<app-adicionar-empresas-modulo-modal
  *ngIf="mostrarModal"
  [idModulo]="idModulo"
  (fechou)="fecharModal()"
  (empresasAdicionadas)="onEmpresasAdicionadas()"
></app-adicionar-empresas-modulo-modal>